/**
 * Created by Ivan on 21.08.2025
 */

const WeeklyGoalsWindow = Prefab.createWindow("weekly_goals", "weekly_goals_window_prefab_json");
